/**
 * @fileoverview gRPC-Web generated client stub for io.codedrills.proto.site
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var io_codedrills_proto_content_content_pb = require('../../../../io/codedrills/proto/content/content_pb.js')

var io_codedrills_proto_content_preview_pb = require('../../../../io/codedrills/proto/content/preview_pb.js')

var io_codedrills_proto_content_view_pb = require('../../../../io/codedrills/proto/content/view_pb.js')

var io_codedrills_proto_content_scoring_pb = require('../../../../io/codedrills/proto/content/scoring_pb.js')

var io_codedrills_proto_content_pagination_pb = require('../../../../io/codedrills/proto/content/pagination_pb.js')
const proto = {};
proto.io = {};
proto.io.codedrills = {};
proto.io.codedrills.proto = {};
proto.io.codedrills.proto.site = require('./content_view_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.site.ContentViewServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.ListContentRequest,
 *   !proto.io.codedrills.proto.site.ListContentResponse>}
 */
const methodInfo_ContentViewService_ListContent = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.ListContentResponse,
  /** @param {!proto.io.codedrills.proto.site.ListContentRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.ListContentResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.ListContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.ListContentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.ListContentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.listContent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/ListContent',
      request,
      metadata || {},
      methodInfo_ContentViewService_ListContent,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.ListContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.ListContentResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.listContent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/ListContent',
      request,
      metadata || {},
      methodInfo_ContentViewService_ListContent);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.GetContentViewRequest,
 *   !proto.io.codedrills.proto.site.GetContentViewResponse>}
 */
const methodInfo_ContentViewService_GetContentView = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.GetContentViewResponse,
  /** @param {!proto.io.codedrills.proto.site.GetContentViewRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.GetContentViewResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.GetContentViewRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.GetContentViewResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.GetContentViewResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.getContentView =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetContentView',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetContentView,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.GetContentViewRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.GetContentViewResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.getContentView =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetContentView',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetContentView);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.GetContentPreviewRequest,
 *   !proto.io.codedrills.proto.site.GetContentPreviewResponse>}
 */
const methodInfo_ContentViewService_GetContentPreview = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.GetContentPreviewResponse,
  /** @param {!proto.io.codedrills.proto.site.GetContentPreviewRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.GetContentPreviewResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.GetContentPreviewRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.GetContentPreviewResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.GetContentPreviewResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.getContentPreview =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetContentPreview',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetContentPreview,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.GetContentPreviewRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.GetContentPreviewResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.getContentPreview =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetContentPreview',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetContentPreview);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.GetContentRequest,
 *   !proto.io.codedrills.proto.site.GetContentResponse>}
 */
const methodInfo_ContentViewService_GetContent = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.GetContentResponse,
  /** @param {!proto.io.codedrills.proto.site.GetContentRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.GetContentResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.GetContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.GetContentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.GetContentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.getContent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetContent',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetContent,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.GetContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.GetContentResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.getContent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetContent',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetContent);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.GetAttachmentRequest,
 *   !proto.io.codedrills.proto.site.GetAttachmentResponse>}
 */
const methodInfo_ContentViewService_GetAttachment = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.GetAttachmentResponse,
  /** @param {!proto.io.codedrills.proto.site.GetAttachmentRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.GetAttachmentResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.GetAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.GetAttachmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.GetAttachmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.getAttachment =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetAttachment',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetAttachment,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.GetAttachmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.GetAttachmentResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.getAttachment =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetAttachment',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetAttachment);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.GetContestScoreboardRequest,
 *   !proto.io.codedrills.proto.site.GetContestScoreboardResponse>}
 */
const methodInfo_ContentViewService_GetContestScoreboard = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.GetContestScoreboardResponse,
  /** @param {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.GetContestScoreboardResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.GetContestScoreboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.GetContestScoreboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.getContestScoreboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetContestScoreboard',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetContestScoreboard,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.GetContestScoreboardResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.getContestScoreboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetContestScoreboard',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetContestScoreboard);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.GetContestScoreboardRequest,
 *   !proto.io.codedrills.proto.site.GetContestScoreboardResponse>}
 */
const methodInfo_ContentViewService_GetContestScoreboardAdmin = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.GetContestScoreboardResponse,
  /** @param {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.GetContestScoreboardResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.GetContestScoreboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.GetContestScoreboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.getContestScoreboardAdmin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetContestScoreboardAdmin',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetContestScoreboardAdmin,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.GetContestScoreboardResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.getContestScoreboardAdmin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetContestScoreboardAdmin',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetContestScoreboardAdmin);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest,
 *   !proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse>}
 */
const methodInfo_ContentViewService_GetContentIdFromUrlAndType = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse,
  /** @param {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.getContentIdFromUrlAndType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetContentIdFromUrlAndType',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetContentIdFromUrlAndType,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.GetContentIdFromUrlAndTypeResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.getContentIdFromUrlAndType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetContentIdFromUrlAndType',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetContentIdFromUrlAndType);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.UserContentPreviewsRequest,
 *   !proto.io.codedrills.proto.site.UserContentPreviewsResponse>}
 */
const methodInfo_ContentViewService_UserContentPreviews = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.UserContentPreviewsResponse,
  /** @param {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.UserContentPreviewsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.UserContentPreviewsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.UserContentPreviewsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.userContentPreviews =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/UserContentPreviews',
      request,
      metadata || {},
      methodInfo_ContentViewService_UserContentPreviews,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.UserContentPreviewsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.UserContentPreviewsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.userContentPreviews =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/UserContentPreviews',
      request,
      metadata || {},
      methodInfo_ContentViewService_UserContentPreviews);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.GetParentPreviewsRequest,
 *   !proto.io.codedrills.proto.site.GetParentPreviewsResponse>}
 */
const methodInfo_ContentViewService_GetParentPreviews = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.GetParentPreviewsResponse,
  /** @param {!proto.io.codedrills.proto.site.GetParentPreviewsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.GetParentPreviewsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.GetParentPreviewsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.GetParentPreviewsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.GetParentPreviewsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.getParentPreviews =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetParentPreviews',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetParentPreviews,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.GetParentPreviewsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.GetParentPreviewsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.getParentPreviews =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetParentPreviews',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetParentPreviews);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.GetChildPreviewsRequest,
 *   !proto.io.codedrills.proto.site.GetChildPreviewsResponse>}
 */
const methodInfo_ContentViewService_GetChildPreviews = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.GetChildPreviewsResponse,
  /** @param {!proto.io.codedrills.proto.site.GetChildPreviewsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.GetChildPreviewsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.GetChildPreviewsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.GetChildPreviewsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.GetChildPreviewsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.getChildPreviews =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetChildPreviews',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetChildPreviews,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.GetChildPreviewsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.GetChildPreviewsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.getChildPreviews =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetChildPreviews',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetChildPreviews);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.GetRestrictedContestsRequest,
 *   !proto.io.codedrills.proto.site.GetRestrictedContestsResponse>}
 */
const methodInfo_ContentViewService_GetRestrictedContests = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.GetRestrictedContestsResponse,
  /** @param {!proto.io.codedrills.proto.site.GetRestrictedContestsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.GetRestrictedContestsResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.GetRestrictedContestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.GetRestrictedContestsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.GetRestrictedContestsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.getRestrictedContests =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetRestrictedContests',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetRestrictedContests,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.GetRestrictedContestsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.GetRestrictedContestsResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.getRestrictedContests =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/GetRestrictedContests',
      request,
      metadata || {},
      methodInfo_ContentViewService_GetRestrictedContests);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.GetContestScoreboardRequest,
 *   !proto.io.codedrills.proto.site.GetContestScoreboardResponse>}
 */
const methodInfo_ContentViewService_DumpContestScoreboard = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.GetContestScoreboardResponse,
  /** @param {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.GetContestScoreboardResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.GetContestScoreboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.GetContestScoreboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.dumpContestScoreboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/DumpContestScoreboard',
      request,
      metadata || {},
      methodInfo_ContentViewService_DumpContestScoreboard,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.GetContestScoreboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.GetContestScoreboardResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.dumpContestScoreboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/DumpContestScoreboard',
      request,
      metadata || {},
      methodInfo_ContentViewService_DumpContestScoreboard);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.RefreshScoreboardRequest,
 *   !proto.io.codedrills.proto.site.RefreshScoreboardResponse>}
 */
const methodInfo_ContentViewService_RefreshScoreboard = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.RefreshScoreboardResponse,
  /** @param {!proto.io.codedrills.proto.site.RefreshScoreboardRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.RefreshScoreboardResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.RefreshScoreboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.RefreshScoreboardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.RefreshScoreboardResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.refreshScoreboard =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/RefreshScoreboard',
      request,
      metadata || {},
      methodInfo_ContentViewService_RefreshScoreboard,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.RefreshScoreboardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.RefreshScoreboardResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.refreshScoreboard =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/RefreshScoreboard',
      request,
      metadata || {},
      methodInfo_ContentViewService_RefreshScoreboard);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.FetchCustomerAllTestRequest,
 *   !proto.io.codedrills.proto.site.FetchCustomerAllTestResponse>}
 */
const methodInfo_ContentViewService_FetchCustomerAllTest = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.FetchCustomerAllTestResponse,
  /** @param {!proto.io.codedrills.proto.site.FetchCustomerAllTestRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.FetchCustomerAllTestResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.FetchCustomerAllTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.FetchCustomerAllTestResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.FetchCustomerAllTestResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.fetchCustomerAllTest =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/FetchCustomerAllTest',
      request,
      metadata || {},
      methodInfo_ContentViewService_FetchCustomerAllTest,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.FetchCustomerAllTestRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.FetchCustomerAllTestResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.fetchCustomerAllTest =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/FetchCustomerAllTest',
      request,
      metadata || {},
      methodInfo_ContentViewService_FetchCustomerAllTest);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.io.codedrills.proto.site.ListCustomerContentRequest,
 *   !proto.io.codedrills.proto.site.ListCustomerContentResponse>}
 */
const methodInfo_ContentViewService_ListCustomerContent = new grpc.web.AbstractClientBase.MethodInfo(
  proto.io.codedrills.proto.site.ListCustomerContentResponse,
  /** @param {!proto.io.codedrills.proto.site.ListCustomerContentRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.io.codedrills.proto.site.ListCustomerContentResponse.deserializeBinary
);


/**
 * @param {!proto.io.codedrills.proto.site.ListCustomerContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.io.codedrills.proto.site.ListCustomerContentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.io.codedrills.proto.site.ListCustomerContentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.io.codedrills.proto.site.ContentViewServiceClient.prototype.listCustomerContent =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/ListCustomerContent',
      request,
      metadata || {},
      methodInfo_ContentViewService_ListCustomerContent,
      callback);
};


/**
 * @param {!proto.io.codedrills.proto.site.ListCustomerContentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.io.codedrills.proto.site.ListCustomerContentResponse>}
 *     A native promise that resolves to the response
 */
proto.io.codedrills.proto.site.ContentViewServicePromiseClient.prototype.listCustomerContent =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/io.codedrills.proto.site.ContentViewService/ListCustomerContent',
      request,
      metadata || {},
      methodInfo_ContentViewService_ListCustomerContent);
};


module.exports = proto.io.codedrills.proto.site;

